
import { useState, useEffect } from 'react';
import useBasePersonData from '@usas/ui-web/state/personBase/UseBasePersonData';

import useEmbeddedReportData from '@usas/ui-web/state/embeddedReport/UseEmbeddedReportData';

const INITIAL_VIEW_STATE = {
  reportParameters: { personId: '' },
  orgUnitId: '',
  routeName: '',
  isLoading: false,
  showReport: false
};

const useMemberRaceStats = () => {
  const { basePersonState } = useBasePersonData();
  const [ viewState, setViewState ] = useState(INITIAL_VIEW_STATE);
  const { reportListState, getEmbeddedReportListForRoute } = useEmbeddedReportData();
  
  const onRunRaceStatsDashboard = () => {
    setViewState({
      ...viewState,
      reportParameters: { personId: basePersonState.objData.personId },
      routeName: 'MEMBER_RACE_STATS',
      isLoading: true,
      reportViewerType: 'Sisense'
    });
  }

  useEffect(() => {
    if (viewState.routeName) {
      const reportListPromise = getEmbeddedReportListForRoute(viewState.routeName);

      if (reportListPromise) {
        reportListPromise.then((stateObj) => {
          if (Array.isArray(stateObj.arrayData)) {
            
            const reportIdx = stateObj.arrayData.findIndex(x => x.reportViewerType === viewState.reportViewerType);

            setViewState({
              ...viewState,
              isLoading: false,
              showReport: stateObj.arrayData.length > 0, 
              reportInfoId: stateObj.arrayData[reportIdx].reportInfoId || -1,
            });
          } else {
            setViewState({
              ...viewState,
              isLoading: false,
              showReport: false,
              reportInfoId: -1
            });
          }
        }).catch((err) => {
          setViewState({
            ...viewState,
            isLoading: false,
            showReport: false,
            reportInfoId: -1
          });
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [viewState.routeName, viewState.reportViewerType]);

  return {
    basePersonState,
    viewState,
    setViewState,
    reportListState,
    onRunRaceStatsDashboard,
    INITIAL_VIEW_STATE
  }
}

export default useMemberRaceStats;